import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerRepairComponent } from './dealer-repair.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { ProviderKeepComponent } from '../provider/provider-keep/provider-keep.component';
import { ProviderKeepOfferComponent } from '../provider/provider-keep-offer/provider-keep-offer.component';
import { NotFoundComponent } from 'src/app/auth/not-found/not-found.component';
import { TransactionStage } from 'src/app/public/common/constants/common-basic-data';

const routes: Routes = [
  { path: '', component: DealerRepairComponent,
    children: [
      { path: 'offer', canActivate: [AuthGuard], component: ProviderKeepOfferComponent },
      { path: 'booking', canActivate: [AuthGuard], component: ProviderKeepComponent, data: { transactionStages: [ TransactionStage.PENDING ]}   },
      { path: 'ongoing', canActivate: [AuthGuard], component: ProviderKeepComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }  },
      { path: 'completed', canActivate: [AuthGuard], component: ProviderKeepComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }   },
    
      { path: '**', component: NotFoundComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerRepairRoutingModule { }
